//   发现好货
export default [{
    path: '/foundGoodGoods',
    name: 'foundGoodGoods',
    meta: {
      index: 2
    },
    component: () => import('@/views/foundGoodGoods/index')
  }]
  